'use client'

import { Builder } from '@builder.io/react'

import { LocaleSwitcher } from '@src/components/LocaleSwitcher/LocaleSwitcher'

Builder.registerComponent(LocaleSwitcher, {
  name: 'LocaleSwitcher',
  image: 'https://unpkg.com/@tabler/icons@2.44.0/icons/world.svg',
})
